import { Option } from "@fresh8/types/src/betData";

export function sortOptionsByOdds(a: Option, b: Option) {
  const aDecimals = a.odds[0] / a.odds[1] + 1;
  const bDecimals = b.odds[0] / b.odds[1] + 1;

  if (aDecimals < bDecimals) {
    return -1;
  }
  if (aDecimals > bDecimals) {
    return 1;
  }
  return 0;
}
